import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
import { LoginPage } from "./login/login";
import { RegistrationPage } from "./registration/registration";
import { IdRegistrationPage } from "./id-registration/id-registration";
const routes: Routes = [
    { path: 'id-registration', loadComponent: () =>
      import('./id-registration/id-registration').then(m => m.IdRegistrationPage)
    },
    { path: 'registration', loadComponent: () =>
      import('./registration/registration').then(m => m.RegistrationPage)
    },
    { path: 'login', loadComponent: () =>
      import('./login/login').then(m => m.LoginPage)
    },
    { path: 'callback', loadComponent: () =>
      import('./oauth-callback/oauth-callback').then(m => m.OAuthCallbackPage)
    },
  ];
@NgModule({
    declarations: [
      LoginPage,
      RegistrationPage,
      IdRegistrationPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        IonicModule,
        FormsModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
      LoginPage,
      RegistrationPage,
      IdRegistrationPage
    ]
  })
  export class AuthModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }